'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.connectStream = connectStream;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _streamCache = require('./streamCache');

var cache = _interopRequireWildcard(_streamCache);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function connectStream(observableFnOrObj) {
  var streamObj = typeof observableFnOrObj === 'function' ? { anuket: observableFnOrObj } : observableFnOrObj;

  return function (WrappedComponent) {
    var _class, _temp;

    return _temp = _class = function (_Component) {
      _inherits(_class, _Component);

      function _class(props) {
        _classCallCheck(this, _class);

        var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));

        _this.state = {};
        return _this;
      }

      _createClass(_class, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
          this._streamFn(this.props);
          this._checkStreamsCacheForData();
        }
      }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
          var props = this.props;
          var changedProps = props.changedProps;


          if (changedProps.length > 0) {
            var diffProps = _lodash2.default.reduce(nextProps, function (result, value, key) {
              // If key is in changedProps and next value does not equal current value, it's different.
              var isDiff = changedProps.indexOf(key) > -1 && !_lodash2.default.isEqual(value, props[key]);

              return isDiff ? result.concat(key) : result;
            }, []);

            if (diffProps.length > 0) {
              this._streamFn(nextProps);
            }
          }
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          this._disposeStream();
        }
      }, {
        key: '_streamFn',
        value: function _streamFn(props) {
          var _this2 = this;

          this._disposeStream();

          var url = typeof currentUrl !== 'undefined' ? currentUrl : location.pathname;

          _lodash2.default.forEach(streamObj, function (val, key) {
            var streamKey = WrappedComponent.name + '-' + key + '-' + url;
            var stream = val(props);
            cache.set(streamKey, {
              ignoreOnServer: stream.ignoreOnServer,
              maxWait: stream.maxWait,
              key: key
            });
            _this2.subscribe[key] = stream.subscribe(function (msg) {
              cache.markLoaded(streamKey);
              if (msg !== null) {
                cache.setAttribute(streamKey, 'data', msg);
                _this2.setState(_lodash2.default.assign({}, _defineProperty({}, key, { isError: false }), _defineProperty({}, key, msg)));
              }
            }, function (err) {
              cache.markLoaded(streamKey);
              _this2.setState(_defineProperty({}, key, { isError: true, err: err }));
            });
          });
        }
      }, {
        key: '_disposeStream',
        value: function _disposeStream() {
          var _this3 = this;

          if (!this.subscribe) {
            this.subscribe = {};
          }

          _lodash2.default.forEach(streamObj, function (val, key) {
            if (_this3.subscribe[key] && _this3.subscribe[key].dispose) {
              _this3.subscribe[key].dispose();
            }
          });
        }
      }, {
        key: '_checkStreamsCacheForData',
        value: function _checkStreamsCacheForData() {
          var _this4 = this;

          var callSetState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

          var url = typeof currentUrl !== 'undefined' ? currentUrl : location.pathname;

          Object.keys(cache.streams).filter(function (key) {
            return new RegExp('^' + WrappedComponent.name + '-.*-' + url + '$', 'g').test(key);
          }).forEach(function (key) {
            var data = cache.streams[key].data;

            if (data) {
              if (callSetState) {
                _this4.setState(_defineProperty({}, cache.streams[key].key, data));
              } else {
                _this4.state = _extends({}, _this4.state, _defineProperty({}, cache.streams[key].key, data));
              }
            }
          });
        }
      }, {
        key: 'render',
        value: function render() {
          return _react2.default.createElement(WrappedComponent, _lodash2.default.assign({}, this.props, this.state));
        }
      }]);

      return _class;
    }(_react.Component), _class.propTypes = {
      changedProps: _react.PropTypes.array
    }, _class.defaultProps = function () {
      var _WrappedComponent$pro = WrappedComponent.propTypes,
          propTypes = _WrappedComponent$pro === undefined ? {} : _WrappedComponent$pro,
          _WrappedComponent$exc = WrappedComponent.excludeChangedProps,
          excludeChangedProps = _WrappedComponent$exc === undefined ? [] : _WrappedComponent$exc;


      return {
        changedProps: (0, _lodash2.default)(propTypes).map(function (prop, key) {
          return key;
        }).filter(function (key) {
          return excludeChangedProps.indexOf(key) === -1;
        }).value()
      };
    }(), _temp;
  };
}


//////////////////
// WEBPACK FOOTER
// ../~/bastetjs/lib/utils/connectStream.js
// module id = 472
// module chunks = 0